module.exports = __webpack_public_path__ + "assets/b276bf7b5f354b3416468decfd025a61.svg";